:host {
  display: block;
  min-width: 30%;
}

.sportsline-free-expert-pick-header{
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* rename using the component name  */
.sportsline-free-expert-pick-header-bar {
  background-color: #4caf50;
  height: 6px;
  width: 100%;
  border-radius: 1rem;
}

.sportsline-free-expert-pick-header-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.sportsline-free-expert-pick-header-icon {
  display: block;
}

.sportsline-free-expert-pick-header-title > h1{
  color: var(--Text-Primary, #202121);
  display: flex;
  flex-direction: column;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.72px;
  max-width: 230px;
  margin: 0;
}

@media screen and (min-width: 768px) {
  .sportsline-free-expert-pick-header-icon {
    display: none;
  }
}

